/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/GameEndDialog',['pixi', 'absolute', 'absolute/stringmanager', 'absolute/assetmap', 'MenuUI/MsftButton', 'lodash',
        'MenuUI/BoostDialog', 'Solitaire/SolitaireGameMode', 'absolute/multipagelist', 'MenuUI/ControlFocusManager',
        'Solitaire/SolitaireGameMode', 'Managers/AdManager', 'Managers/TelemetryManager', 'Managers/ScaleManager',
        'Solitaire/MvvmStructure/Service/SolitaireStarClubService', 'Arkadium/GameEngine/Core/EngineManagers'
    ],
    function (PIXI, Absolute, _s, _a, MsftButton, _, BoostDialog, SolitaireGameMode, MultiPageList, ControlFocusManager,
              SolitaireGameMode, AdManager, TelemetryManager, ScaleManager, SolitaireStarClubService, EngineManagers) {

        var GameEndDialog = function (ui, game, options) {
            this.initGameEndDialog(ui, game, options);
        };

        GameEndDialog.prototype = Object.create(Absolute.Dialog.prototype);

        GameEndDialog.prototype.initGameEndDialog = function (ui, game, options) {

            this.ui = ui;
            this.game = game;
            this.options = options;
            this.options.width = Absolute.Coords.x(1632);
            this.options.height = Absolute.Coords.y(831);
            this.options.content = this.initContent();
            this.options.displayCloseButton = false;
            this.options.backgroundAlpha = 0.7;
            this.sectionSelected = false;
            this.scrollAreaHeightConst = 480;
            this.buttonPositionTop = 725;

            this.isLoss = (this.options.dialog.indexOf('GameOver') > -1);

            this.statScroll = new Absolute.ScrollArea(Absolute.Coords.x(631), Absolute.Coords.x(this.scrollAreaHeightConst), {x: true}, new PIXI.Texture.fromFrame('game_end/scrollbar_button_idle.png'), function () {
            });

            this.controlFocusManager = new ControlFocusManager();
            this.clickHandler = this.handleGameInput.bind(this);
            window.addEventListener('click', this.clickHandler);

            this.buttonLetterStyle = {
                font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 50 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left'
            };
            this.threeSliceOrange = {
                multistate: true,
                images: {
                    'left': _a('buttonThreeSliceOrange.left'),
                    'center': _a('buttonThreeSliceOrange.center'),
                    'right': _a('buttonThreeSliceOrange.right')
                }
            };
            this.threeSliceBlue = {
                multistate: true,
                images: {
                    'left': _a('buttonThreeSliceBlue.left'),
                    'center': _a('buttonThreeSliceBlue.center'),
                    'right': _a('buttonThreeSliceBlue.right')
                }
            };

            Absolute.Dialog.call(this, ui, this.options);
            this.options.tween.type = 'tweenIn';

            if (this.options.challenge) {

                this.buildChallengeButtons();
                this.fireWorkLayer = new PIXI.DisplayObjectContainer();
                this.fireWorkClips = [];

                this.addChild(this.fireWorkLayer);
                _.times(7, function () {
                    var clip = Absolute.SpriteUtils.loadMovieClip('game_end/fireworks/Fireworks3_', 81, 1);
                    clip.scale.x = clip.scale.y = 4;
                    clip.anchor.x = clip.anchor.y = 0.5;
                    clip.animationSpeed = 0.5;
                    clip.loop = false;
                    clip.x = Math.max(this.options.width * 0.20, Math.random() * this.options.width * 0.80);
                    clip.y = Math.max(this.options.height * 0.20, Math.random() * this.options.height * 0.80);
                    clip.visible = false;
                    this.fireWorkClips.push(clip);
                    this.fireWorkLayer.addChild(clip);
                }, this);

            } else {
                this.buildButtons();
            }
            this.initForceScaleSprite();
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
        };

        GameEndDialog.prototype.initForceScaleSprite = function () {
            this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
            this.forceOffsetX = Absolute.Coords.x(70);
            this.forceOffsetY = Absolute.Coords.y(70);
            this.forceScaleSprite.width = Absolute.Coords.x(1720);
            this.forceScaleSprite.height = Absolute.Coords.y(960);
            this.forceScaleSprite.alpha = 0;
            this.addChild(this.forceScaleSprite);
        };

        GameEndDialog.prototype.handleResize = function () {
            if (this.parent) this.updateTransform();
            var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
            this.scale.set(1, 1);
            var initialWidth = this.width, initialHeight = this.height;
            this.scale.set(oldScaleX, oldScaleY);
            var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
                screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
                roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
            this.width = initialWidth * screenScaleX;
            this.height = initialHeight * screenScaleY;
            var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
            var widthToShow = initialWidth, heightToShow = initialHeight;
            var tookCare = false;
            if (realWidth > roomWidth) {
                this.width = Absolute.Coords.x(1920);
                var delta = roomWidth / widthToShow;
                this.height = ((initialHeight * screenScaleY) * delta);
                if ((this.height / screenScaleY) > roomHeight) {
                    this.height = Absolute.Coords.y(1080);
                    var delta = roomHeight / heightToShow;
                    this.width = ((initialWidth * screenScaleX) * delta);
                }
                tookCare = true;
            }
            if (!tookCare && (realHeight > roomHeight)) {
                this.height = Absolute.Coords.y(1080);
                var delta = roomHeight / heightToShow;
                this.width = ((initialWidth * screenScaleX) * delta);
                if ((this.width / screenScaleX) > roomWidth) {
                    this.width = Absolute.Coords.x(1920);
                    var delta = roomWidth / widthToShow;
                    this.height = ((initialHeight * screenScaleY) * delta);
                }
            }
            this.x = (EngineManagers.Display.Width * .5) - (this.width / 2) + this.forceOffsetX;
            this.y = (EngineManagers.Display.Height * .5) - (this.height / 2) + this.forceOffsetY;
        };

        GameEndDialog.prototype.initContent = function () {
            this.contentContainer = Absolute.UIBuilder.buildLayout(this.options.dialog, this, this, this.options.width, this.options.height);
            return this.contentContainer;
        };

        GameEndDialog.prototype.newGameButtonAction = function () {
        };

        GameEndDialog.prototype.close = function () {
            Absolute.Dialog.prototype.close.call(this);
            window.removeEventListener('click', this.clickHandler);
            ScaleManager.removeElement(this);
            this.destroy(true);
        };

        GameEndDialog.prototype.open = function () {
            Absolute.Dialog.prototype.open.call(this);
            if (this.options.dialog === 'ChallengeWinDialog') {
                window.setTimeout(function () {
                    _.each(this.fireWorkClips, function (clip, index) {
                        window.setTimeout(function () {
                            Absolute.AudioManager.playSound('firework' + (Math.round(Math.random() * 3) + 1).toString());
                            clip.visible = true;
                            clip.gotoAndPlay(0);
                        }, 100 * index);
                    });
                }.bind(this), 300);
            } else if (this.options.dialog.indexOf('GameOver') > -1) {
                Absolute.AudioManager.playSound('gameOver');
            }
            var win = this.options.dialog.indexOf('GameOver') === -1,
                mode = this.options.challenge ? this.options.challenge.GetModeName() : '',
                timeSpent = Math.floor(this.game.solitaire.Authority.CardSupply.PreciseTimePlayed),
                gameResult = win ? 'Win' : 'Fail';
            if (this.options.challenge) {
                var difficulty = this.options.challenge.config.Difficulty;
                if (this.options.challenge.IsStarClub) {
                    var collectionName = SolitaireStarClubService.currentCollection.Name,
                        packName = SolitaireStarClubService.currentPack.Name;
                    TelemetryManager.starClubComplete(gameResult, timeSpent, mode, difficulty, collectionName, packName);
                } else {
                    var timestampStr = this.options.challenge.config.Date.substring(6, 19);
                    var date = new Date(parseInt(timestampStr));
                    var releaseDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                    TelemetryManager.challengeComplete(gameResult, mode, timeSpent, releaseDate, difficulty)
                }
            } else if (win) {
                TelemetryManager.classicGameComplete(
                    gameResult, this.game.solitaire.Authority.CardSupply.GameName, timeSpent,
                    this.game.solitaire.ScoringOption, this.game.solitaire.DrawOption,
                    this.game.solitaire.SuitsOption,
                    this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY
                );
            }
        };

        GameEndDialog.prototype.updateStats = function (model) {

            this.model = model;

            var statLetterStyle = {
                font: Absolute.ScreenMetrics.getResScale() * 50 + 'px Arial',
                fill: '#000001',
                fontFamily: 'segoe',
                tint: 0x000001,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: Absolute.Coords.x(392)
            };

            if (this.options.challenge) {
                var titleLetterStyle = {
                        font: Absolute.ScreenMetrics.getResScale() * 50 + 'px Arial',
                        fill: '#ea3517',
                        fontFamily: 'segoe',
                        tint: 0xea3517,
                        align: 'left'
                    },
                    goalTitle = new PIXI.Text(Absolute.StringManager('stats.goal'), titleLetterStyle),
                    goalText = new PIXI.Text(this.options.challenge.GetGoalDescription(), statLetterStyle),
                    scoreTitle = new PIXI.Text(Absolute.StringManager('stats.yourScore'), titleLetterStyle),
                    scoreText = new PIXI.Text(this.game.solitaire.Authority.CardSupply.Score.toString() + '\n ', statLetterStyle), // the \n is fixing a clipping issue
                    goalBox = new PIXI.Graphics(),
                    scoreBox = new PIXI.Graphics(),
                    challengeTray = new PIXI.DisplayObjectContainer();

                challengeTray.x = Absolute.Coords.x(459);
                challengeTray.y = Absolute.Coords.y(190);

                scoreTitle.x = goalTitle.x = Absolute.Coords.x(35);
                scoreTitle.y = goalTitle.y = Absolute.Coords.y(10);

                scoreText.updateText();
                scoreText = new PIXI.Sprite(scoreText.generateTexture());
                scoreText.anchor.x = 1;
                scoreText.x = Absolute.Coords.x(561);
                scoreText.y = Absolute.Coords.y(10);

                goalBox.beginFill(0xffffff, 1);
                goalBox.drawRect(0, 0, Absolute.Coords.x(631), goalText.height + Absolute.Coords.y(40));
                goalBox.endFill();


                goalText.updateText();
                goalText.x = goalBox.width - goalText.width - Absolute.Coords.x(72);
                goalText.y = Absolute.Coords.y(17);


                goalBox.addChild(goalText);
                goalBox.addChild(goalTitle);

                scoreBox.beginFill(0xffffff, 1);
                scoreBox.drawRect(0, 0, Absolute.Coords.x(631), Absolute.Coords.y(72));
                scoreBox.endFill();
                scoreBox.y = goalBox.height + Absolute.Coords.y(8);
                scoreBox.addChild(scoreTitle);
                scoreBox.addChild(scoreText);

                challengeTray.addChild(goalBox);
                challengeTray.addChild(scoreBox);

                this.addChild(challengeTray);
                this.addChild(this.fireWorkLayer);

            } else {
                var stats = [];

                _.forEach(model, function (stat, name) {
                    if (name !== 'LosingStreak') {
                        stats.push({title: _s("stats.item." + name), value: stat});
                    }
                });

                var index = 0;

                var statTray = new PIXI.DisplayObjectContainer(),
                    statBoxes = [];
                this.statScroll.x = Absolute.Coords.x(459);
                this.statScroll.y = Absolute.Coords.y(190);
                _.each(stats, function (stat) {

                    var statBox = new PIXI.Graphics(),
                        statTitle = new PIXI.Text(stat.title, statLetterStyle),
                        statValue = new PIXI.Text(stat.value, statLetterStyle),
                        padding = Absolute.Coords.x(8),
                        yOffset = 0,
                        boxHeight = statTitle.height + Absolute.Coords.y(29);

                    statBox.beginFill(0xffffff, 1);
                    statBox.drawRect(0, 0, Absolute.Coords.x(631), boxHeight);
                    statBox.endFill();
                    statBox.x = 0;
                    statBox.y = yOffset + index * (boxHeight + padding);

                    statTitle.x = Absolute.Coords.x(35);
                    statTitle.y = Absolute.Coords.y(12);
                    statValue.x = Absolute.Coords.x(460);
                    statValue.y = Absolute.Coords.y(12);

                    statBox.addChild(statTitle);
                    statBox.addChild(statValue);

                    statBoxes.push(statBox);

                    statTray.addChild(statBox);

                    index++;

                }, this);

                //this.statScroll.addItem(statTray);
                //this.addChild(this.statScroll);

                var scrollAreaHeight = Absolute.Coords.y(this.scrollAreaHeightConst),
                    scrollAreaWidth = Absolute.Coords.y(631),
                    multiPageLayout = {
                        direction: "vertical",
                        pageWidth: scrollAreaWidth,
                        pageHeight: Absolute.Coords.y(400),
                        itemWidth: scrollAreaWidth,
                        itemHeight: Absolute.Coords.y(72),
                        maskRect: {
                            x: Absolute.Coords.x(0),
                            y: Absolute.Coords.y(0),
                            width: scrollAreaWidth,
                            height: scrollAreaHeight
                        },
                        gap: Absolute.Coords.x(6)
                    },
                    activeTexture = new PIXI.Texture.fromFrame('btn_arrow_ring.png'),
                    scrollAreaBackground = new PIXI.Graphics();
                this.upArrowButton = new PIXI.Sprite(activeTexture);
                this.downArrowButton = new PIXI.Sprite(activeTexture);

                scrollAreaBackground.beginFill(0x000000, 0.5);
                scrollAreaBackground.drawRect(0, 0, scrollAreaWidth, scrollAreaHeight);
                scrollAreaBackground.endFill();

                this.upArrowButton.scale.x = this.upArrowButton.scale.y = this.downArrowButton.scale.x = this.downArrowButton.scale.y = 0.5;
                this.upArrowButton.anchor.x = this.upArrowButton.anchor.y = this.downArrowButton.anchor.x = this.downArrowButton.anchor.y = 0.5;
                this.upArrowButton.rotation = 1.57079633;
                this.downArrowButton.rotation = 4.71238898;


                this.downArrowButton.setActive = this.upArrowButton.setActive = function (active, arrow) {
                    arrow.alpha = active ? 1 : 0.2;
                    arrow.interactive = active;
                    arrow.buttonMode = active;
                };

                Absolute.SpriteUtils.bindInteraction(this.upArrowButton, function () {
                    this.multiPageList.scrollDown();
                }.bind(this));

                Absolute.SpriteUtils.bindInteraction(this.downArrowButton, function () {
                    this.multiPageList.scrollUp();
                }.bind(this));

                this.multiPageList = new MultiPageList(this.ui, statBoxes, this.upArrowButton, this.downArrowButton, multiPageLayout);
                this.multiPageList.setLayout(multiPageLayout);
                this.multiPageList.reset();
                this.multiPageList.x = Absolute.Coords.x(459);
                this.multiPageList.y = Absolute.Coords.y(190);

                this.multiPageList.addChildAt(scrollAreaBackground, 0);

                this.controlFocusManager.addControl(this.multiPageList, true, 'Statistics');

                this.upArrowButton.x = this.multiPageList.x + this.multiPageList.width / 2;
                this.upArrowButton.y = this.multiPageList.y - Absolute.Coords.y(15);
                this.downArrowButton.x = this.multiPageList.x + this.multiPageList.width / 2;
                this.downArrowButton.y = this.multiPageList.y + scrollAreaHeight + Absolute.Coords.y(15);

                this.upArrowButton.visible = this.downArrowButton.visible = this.multiPageList.pages.length > 1;

                this.addChild(this.multiPageList);
                this.addChild(this.upArrowButton);
                this.addChild(this.downArrowButton);

                this.addChild(this.buttonContainer);

                this.multiPageList.initHoverLayer();
            }

        };

        GameEndDialog.prototype.buildChallengeButtons = function () {
            var buttons;
            if (this.isLoss) {

                buttons = [
                    {
                        'text': _s('buttons.tryAgain'),
                        'threeSlice': this.threeSliceOrange,
                        'width': 180, 'height': 72,
                        'maxWidth': Absolute.Coords.x(160),
                        'position': {"x": 459, "y": this.buttonPositionTop},
                        'action': function () {
                            var gameMode = this.game.solitaire.ActiveMode.Name,
                                challenge = this.game.solitaire.CurrentChallenge;
                            this.game.solitaire.StopGame(false);
                            this.game.startGame(gameMode, challenge);
                            this.close();
                        }.bind(this)
                    },
                    {
                        'text': _s('buttons.homeButton'),
                        'threeSlice': this.threeSliceBlue,
                        'maxWidth': Absolute.Coords.x(100),
                        'width': 126, 'height': 72,
                        'position': {'x': 658, 'y': this.buttonPositionTop},
                        'action': function () {
                            this.game.onNavMain();
                            this.close();
                        }.bind(this)
                    },
                    {
                        'text': _s('buttons.undoLastMove'),
                        'maxWidth': Absolute.Coords.x(280),
                        'threeSlice': this.threeSliceOrange,
                        'width': 300, 'height': 72,
                        'position': {'x': 804, 'y': this.buttonPositionTop},
                        'action': function () {
                            this.game.solitaire.Undo();
                            this.ui.unBlockClicks();
                            this.close();
                        }.bind(this)
                    }];

            } else {
                buttons = [
                    {
                        'text': _s('buttons.collectReward'),
                        'threeSlice': this.threeSliceOrange,
                        'width': 270, 'height': 72,
                        'maxWidth': Absolute.Coords.x(250),
                        'position': {'x': 640, 'y': this.buttonPositionTop},
                        'action': function () {
                            Absolute.AudioManager.stopAll();
                            Absolute.AudioManager.playSound('button');
                            this.game.navBack();
                            this.close();
                        }.bind(this)
                    }
                ];
            }

            this.addButtons(buttons);
        };

        GameEndDialog.prototype.buildButtons = function () {

            var buttons = [
                {
                    'text': _s('buttons.newGameButton'),
                    'threeSlice': this.threeSliceOrange,
                    'width': 196, 'height': 72,
                    'maxWidth': Absolute.Coords.x(180),
                    'position': {"x": 557, "y": this.buttonPositionTop},
                    'action': function () {
                        if (this.model.LosingStreak >= 5 &&
                            (this.game.solitaire.ActiveMode.Name === SolitaireGameMode.Pyramid ||
                                this.game.solitaire.ActiveMode.Name === SolitaireGameMode.TriPeaks)) {
                            var boostDialog = new BoostDialog(this.ui.currentScreen, 'dialogs.boostHeadline',
                                'dialogs.boostContent', function (boostType) {
                                    if (boostType !== 'no') {
                                        this.ui.blockClicks();
                                        AdManager.tryShowAd(function () {
                                            this.game.boostType = boostType;
                                            this.game.solitaire.Authority.ApplyCurrentOptInAdBonus(boostType);
                                            this.ui.unBlockClicks();
                                        }.bind(this), true, true);
                                    } else {
                                        this.game.solitaire.DeleteSavedGame();
                                        this.game.boostType = 'no';
                                        this.game.solitaire.DealNewGame();
                                    }
                                    boostDialog.close();
                                }.bind(this));
                            this.close();
                        } else {
                            this.game.solitaire.DeleteSavedGame();
                            this.game.boostType = 'no';
                            this.game.solitaire.DealNewGame();
                            this.close();
                        }

                    }.bind(this)
                },
                {
                    'text': _s('buttons.homeButton'),
                    'threeSlice': this.threeSliceBlue,
                    'width': 196, 'height': 72,
                    'maxWidth': Absolute.Coords.x(180),
                    'position': {'x': 796, 'y': this.buttonPositionTop},
                    'action': function () {
                        this.game.solitaire.DeleteSavedGame();
                        this.game.navMain();
                        this.close();
                    }.bind(this)
                }
            ];

            if (this.game.config.singleGame.enabled && !this.isLoss) {
                buttons.pop();
                buttons[0].position.x += 120;
            }

            if (this.isLoss && this.game.solitaire.ActiveMode.Name !== SolitaireGameMode.TriPeaks &&
                this.game.solitaire.ActiveMode.Name !== SolitaireGameMode.Pyramid) {
                buttons[0].position.x = 459;
                buttons[1].position.x = 678;
                buttons.push(
                    {
                        'text': _s('buttons.tryAgain'),
                        'threeSlice': this.threeSliceBlue,
                        'maxWidth': Absolute.Coords.x(180),
                        'width': 196, 'height': 72,
                        'position': {'x': 894, 'y': this.buttonPositionTop},
                        'action': function () {
                            this.game.solitaire.DeleteSavedGame();
                            this.game.solitaire.DealNewGame(this.game.solitaire.Authority.CardSupply.DeckSeed);
                            this.close();
                        }.bind(this)

                    }
                );
                if (this.game.config.singleGame.enabled) {
                    buttons.splice(1, 1);
                }
            }

            if ((this.game.config.singleGame.enabled) && (this.isLoss)) {
                buttons[0].position.x = 555;
                buttons[1].position.x = 800;
            }

            this.addButtons(buttons);

        };

        GameEndDialog.prototype.addButtons = function (buttons) {

            this.buttonContainer = new PIXI.DisplayObjectContainer();

            _.each(buttons, function (button) {
                var options = _.extend(button, {
                        'letterStyle': this.buttonLetterStyle
                    }),
                    button;
                options.width = Absolute.Coords.x(options.width);
                options.height = Absolute.Coords.x(options.height);
                button = new MsftButton(options);
                button.x = Absolute.Coords.x(options.position.x);
                button.y = Absolute.Coords.x(options.position.y);

                this.buttonContainer.addChild(button);

                this.controlFocusManager.addControl(button, false, 'Buttons');

            }, this);

            this.addChild(this.buttonContainer);
            // this.controlFocusManager.focusNextControl(1);
        };

        GameEndDialog.prototype._createBackground = function () {

            //this.nineSlice = 'fake';

            var backgroundTexture = new PIXI.Texture.fromFrame('game_end/gameEnd_background_symbols.png'),
                backgroundGradient = PIXI.Sprite.fromFrame('game_end/gameEnd_background_gradient.png'),
                headlineBanner = PIXI.Sprite.fromFrame('game_end/gameEnd_redstrip_center.png'),
                headlineBannerCap = PIXI.Sprite.fromFrame('game_end/gameEnd_redstrip_tip.png'),
                cards = PIXI.Sprite.fromFrame('game_end/gameEnd_cards.png'),
                adBackground = new PIXI.Graphics(),
                adHorizontalRule = PIXI.Sprite.fromFrame('game_end/gameEnd_strip.png'),
                fakeAd = PIXI.Sprite.fromFrame('game_end/ads_casualgames.png');

            this.backgroundTile = new PIXI.TilingSprite(backgroundTexture, this.options.width, this.options.height);

            backgroundGradient.width = this.options.width;
            backgroundGradient.height = this.options.height;

            headlineBanner.y = Absolute.Coords.y(77);
            headlineBannerCap.x = headlineBanner.width;
            headlineBanner.addChild(headlineBannerCap);

            cards.x = -Absolute.Coords.x(47);
            cards.y = Absolute.Coords.y(190);

            adBackground.beginFill(0x000000, 0.7);
            adBackground.drawRect(0, 0, Absolute.Coords.x(426), Absolute.Coords.y(615));
            adBackground.endFill();
            adBackground.x = Absolute.Coords.x(1143);
            adBackground.y = Absolute.Coords.y(190);
            adHorizontalRule.y = Absolute.Coords.y(496);
            fakeAd.x = (adBackground.width - fakeAd.width) / 2;
            fakeAd.y = (adHorizontalRule.y - fakeAd.height) / 2;
            adBackground.addChild(adHorizontalRule);
            adBackground.addChild(fakeAd);

            this.addChildAt(adBackground, 0);
            this.addChildAt(cards, 0);
            this.addChildAt(headlineBanner, 0);
            this.addChildAt(backgroundGradient, 0);
            this.addChildAt(this.backgroundTile, 0);

        };

        GameEndDialog.prototype.handleCommand = function (command) {
            this.selectSection(command);
            switch (command) {
                case 'Right':
                    if (!this.sectionSelected) return;
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'Left':
                    if (!this.sectionSelected) return;
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Up':
                    if (!this.sectionSelected) return;
                    if (this.upArrowButton && this.upArrowButton.visible && this.multiPageList.focus) {
                        this.multiPageList.scrollDown();
                    } else {
                        this.controlFocusManager.focusNextControl(-1);
                    }
                    break;
                case 'Down':
                    if (!this.sectionSelected) return;
                    if (this.downArrowButton && this.downArrowButton.visible && this.multiPageList.focus) {
                        this.multiPageList.scrollUp();
                    } else {
                        this.controlFocusManager.focusNextControl(1);
                    }
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
                case 'Unfocus':
                    this.controlFocusManager.unfocusCurrentControl();
                    break;
            }
        };


        GameEndDialog.prototype.selectSection = function (command) {
            if (command === 'Tab' || command === 'ShiftTab') {
                this.sectionSelected = true;
                if (command === 'Tab') {
                    if (!this.upArrowButton || !this.downArrowButton || !this.upArrowButton.visible || !this.downArrowButton.visible) {
                        this.page = 1;
                        this.handlePageChange(this.page, 1);
                    } else {
                        this.handlePageChange(this.page, (this.page === 0 && !this.page) ? 1 : 0);
                    }
                } else if (command === 'ShiftTab') {
                    if (!this.upArrowButton || !this.downArrowButton || !this.upArrowButton.visible || !this.downArrowButton.visible) {
                        this.page = 1;
                        this.handlePageChange(this.page, 1);
                    } else {
                        this.handlePageChange(this.page, (!this.page) ? 1 : 0);
                    }
                }
                switch (this.controlFocusManager.currentFocusGroup) {
                    case 'Statistics':
                        this.page = 0;
                        break;
                    case 'Buttons':
                        this.page = 1;
                        break;
                }
            }
        };

        GameEndDialog.prototype.handlePageChange = function (from, to) {
            switch (to) {
                case 0:
                    this.controlFocusManager.setFocusGroup('Statistics');
                    break;
                case 1:
                    this.controlFocusManager.setFocusGroup('Buttons');
                    break;
            }
        };

        GameEndDialog.prototype.handleGameInput = function () {
            this.resetControlManager();
        };

        GameEndDialog.prototype.resetControlManager = function () {
            this.controlFocusManager.unfocusCurrentControl();
            this.sectionSelected = false;
        };

        return GameEndDialog;

    });

